import { Route } from "@angular/router";

export const CONNECTIONS_ROUTES: Route[] = [
  {
    path: "connections",
    children: [
      {
        path: "",
        loadComponent: () => import("./connections").then((m) => m.ConnectionsComponent),
        data: {
          title: "plusbutton.connect",
          breadcrumb: "plusbutton.connect",
        },
      },
    ],
  },
];
